import React from 'react';
import axios from "axios";
import App from './App';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import configureStore from "./reducers/stores/storeMain";
import './index.css';
import { WEB_AUTH_URL, WEB_CORE_URL } from './configurations/paths.config';

initializeIcons();

let isRefreshing = false;
let isLoggingOut = false;
let failedQueue = [];

const SKIP_REFRESH_URLS = [
    '/api/refreshToken',
    '/get-tk',
    '/set-tk',
    '/set-tke',
    '/set-tkk',
    '/remove-cookies-api',
    '/remove-cookies',
    '/remove-cookies-ext',
];

const NO_ACCESS_PATH = '/NoDataAccess';

const hasAccessValidationResult = (response) => {
    const aux = (
        response &&
        response.data &&
        response.data.data &&
        Object.prototype.hasOwnProperty.call(response.data.data, 'acceso_elemento')
    )

    return aux;
};

const shouldRedirectToNoAccess = (response) => {
    const aux = !hasAccessValidationResult(response);
    console.log(aux)
    if (aux) {
        return false;
    }
    console.log(response.config)
    console.log(response.config.__skipAccessValidation)
    if (response.config && response.config.__skipAccessValidation === true) {
        return false;
    }
    console.log(window.location.pathname)
    if (window.location.pathname === NO_ACCESS_PATH) {
        return false;
    }
    console.log("isAdmin", response.data.data.isAdmin)
    console.log("onlyObserver", response.data.data.onlyObserver)
    console.log("acceso_elemento", response.data.data.acceso_elemento)
    return response.data.data.isAdmin === true || response.data.data.onlyObserver === true ? false : response.data.data.acceso_elemento === false;
};

const redirectToNoAccess = () => {
    if (window.location.pathname !== NO_ACCESS_PATH) {
        window.location.href = NO_ACCESS_PATH;
    }
};

const shouldLogoutOnSessionExpired = (config) => {
    const url = getRequestUrl(config);

    if (config && config._retry === true) {
        return true;
    }

    return SKIP_REFRESH_URLS.some((logoutUrl) => url.indexOf(logoutUrl) !== -1);
};

const processQueue = (error) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        }
        else {
            prom.resolve();
        }
    });

    failedQueue = [];
};

const getRequestUrl = (config) => {
    return config && config.url ? config.url : "";
};

const shouldSkipRefresh = (config) => {
    const url = getRequestUrl(config);

    if (config && config.__skipRefresh === true) {
        return true;
    }

    return SKIP_REFRESH_URLS.some((skipUrl) => url.indexOf(skipUrl) !== -1);
};

const removeCoreCookies = async () => {
    try {
        await axios({
            method: "GET",
            url: `${WEB_CORE_URL}/remove-cookies-api`,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
            __skipRefresh: true,
        });
    }
    catch (error) {
        // Si la limpieza de cookies del proyecto core falla, igualmente se redirige al auth.
    }
};

const redirectToAuthLogout = async () => {
    if (isLoggingOut) return;
    isLoggingOut = true;
    await removeCoreCookies();
    window.location.href = `${WEB_AUTH_URL}/logout?stats=success`;
};

axios.interceptors.response.use(
    (response) => {
        const code = response && response.data && response.data.code ? response.data.code : null;

        if (
            (code === 'SESSION_COOKIES_ERROR' || code === 'SESSION_REMOVED') &&
            !shouldSkipRefresh(response.config)
        ) {
            redirectToAuthLogout();
            return Promise.reject(new Error(code));
        }

        if (response.config.url.indexOf("/api/Privilege/securityProps") !== -1 && shouldRedirectToNoAccess(response)) {
            redirectToNoAccess();
            return Promise.reject(new Error('NO_ACCESS'));
        }

        return response;
    },
    async (error) => {
        const originalRequest = error && error.config ? error.config : null;
        const response = error && error.response ? error.response : null;

        if (!response || !originalRequest) {
            return Promise.reject(error);
        }

        const status = response.status;
        const responseData = response.data;
        const code = responseData && responseData.code ? responseData.code : null;

        if ((
            status === 401 &&
            code !== 'SESSION_CREATED_ERROR' &&
            originalRequest._retry !== true &&
            shouldSkipRefresh(originalRequest) === false
        ) || (status === 400 && responseData === 'MdLw-Unauthorized')) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then(() => axios(originalRequest))
                    .catch((queueError) => Promise.reject(queueError));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                await axios.post('/api/refreshToken', null, { __skipRefresh: true });
                processQueue(null);
                return axios(originalRequest);
            }
            catch (refreshError) {
                processQueue(refreshError);

                const refreshResponse = refreshError && refreshError.response ? refreshError.response : null;
                const refreshData = refreshResponse && refreshResponse.data ? refreshResponse.data : null;
                const refreshCode = refreshData && refreshData.code ? refreshData.code : null;

                if (
                    refreshCode === 'SESSION_EXPIRED' ||
                    refreshCode === 'SESSION_REMOVED' ||
                    refreshCode === 'SESSION_COOKIES_ERROR'
                ) {
                    await redirectToAuthLogout();
                }

                return Promise.reject(refreshError);
            }
            finally {
                isRefreshing = false;
            }
        }

        if (status === 401 && code === 'SESSION_EXPIRED') {
            if (shouldLogoutOnSessionExpired(originalRequest)) {
                await redirectToAuthLogout();
            }

            return Promise.reject(error);
        }

        return Promise.reject(error);
    }
);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={configureStore}>
        <App />
    </Provider>
);